import { OAuthPopupMessage } from "./oauthPopupMessage";

/**
 * Decodes the OAuth deep-link URL delivered by Capacitor's `appUrlOpen` event 
 * back into the existing `OAuthPopupMessage` type.
 */
export function parseOAuthBridgeUrl(url: string): OAuthPopupMessage | null {
  try {
    let payloadStr: string | null = null;

    try {
      const urlObj = new URL(url);
      payloadStr = urlObj.searchParams.get("payload");
    } catch (e) {
      // Fallback for custom schemes that URL constructor might fail on in some environments
      const match = url.match(/[?&]payload=([^&#]+)/);
      if (match && match[1]) {
        payloadStr = decodeURIComponent(match[1]);
      }
    }

    if (!payloadStr) {
      return null;
    }

    // Base64url-decode
    // Replace non-url compatible chars with base64 standard chars
    let base64 = payloadStr.replace(/-/g, "+").replace(/_/g, "/");
    
    // Pad with '=' to a multiple of 4
    const pad = base64.length % 4;
    if (pad) {
      if (pad === 1) {
        throw new Error("Invalid base64url string length");
      }
      base64 += new Array(5 - pad).join("=");
    }

    // Decode base64
    const binary = atob(base64);
    
    // UTF-8 decode
    const jsonString = decodeURIComponent(escape(binary));

    // Parse JSON
    const parsed = JSON.parse(jsonString);

    if (!parsed || typeof parsed !== "object") {
      throw new Error("Payload is not an object");
    }

    // Validate shape
    if (parsed.type === "OAUTH_TOKEN_SUCCESS") {
      if (typeof parsed.token !== "string" || parsed.token === "") {
        throw new Error("OAUTH_TOKEN_SUCCESS missing token string");
      }
      return parsed as OAuthPopupMessage;
    }
    
    if (parsed.type === "OAUTH_SUCCESS") {
      if (!parsed.user || typeof parsed.user !== "object") {
        throw new Error("OAUTH_SUCCESS missing user object");
      }
      return parsed as OAuthPopupMessage;
    }

    if (parsed.type === "OAUTH_ERROR") {
      if (!parsed.error || typeof parsed.error.message !== "string") {
        throw new Error("OAUTH_ERROR missing error.message string");
      }
      return parsed as OAuthPopupMessage;
    }

    throw new Error(`Unknown type: ${parsed.type}`);

  } catch (error) {
    const snippet = url.substring(0, 100) + (url.length > 100 ? "..." : "");
    console.error(`Failed to parse OAuth bridge URL. Error: ${error instanceof Error ? error.message : "Unknown"}. URL snippet: ${snippet}`);
    return null;
  }
}